import { useState, useEffect } from 'react';
import { updateFileConfig, getFileConfig } from '../config/appConfig';
import { extractionAPI } from '../services/extractionAPI';

/**
 * Hook para manejar la configuración dinámica de la aplicación
 * Sincroniza la configuración del frontend con el backend
 */
export const useAppConfig = () => {
  const [config, setConfig] = useState(getFileConfig());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadServerConfig = async () => {
      try {
        setLoading(true);
        const response = await extractionAPI.getExtractionConfig();
        
        if (response.success) {
          // Actualizar configuración global
          updateFileConfig(response.data);
          // Actualizar estado local
          setConfig(getFileConfig());
          setError(null);
        } else {
          console.warn('No se pudo obtener configuración del servidor, usando valores por defecto');
          setError(response.error);
        }
      } catch (err) {
        console.error('Error al cargar configuración:', err);
        setError(err.message || 'Error al cargar configuración');
      } finally {
        setLoading(false);
      }
    };

    loadServerConfig();
  }, []);

  return {
    config,
    loading,
    error,
    refreshConfig: async () => {
      setLoading(true);
      try {
        const response = await extractionAPI.getExtractionConfig();
        if (response.success) {
          updateFileConfig(response.data);
          setConfig(getFileConfig());
          setError(null);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
  };
};

export default useAppConfig;
